import React from "react";
import "./TotalPrice.css";
import { useConfiguration } from "src/contexts/ConfigurationContext";

const TotalPrice: React.FC = () => {
  const { totalPrice } = useConfiguration();

  return (
    <div className="configurator-total-price">
      <span>{totalPrice}</span>
      <span className="total-price-sub">incl. BTW</span>
    </div>
  );
};

export default TotalPrice;
